<template>
  <span>
    <el-button type="default" icon="fa fa-plus" @click="dialogVisible = true" />
    <el-dialog
      title="Create Distribution Channel"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      append-to-body>
      <el-form label-position="left" label-width="120px" :model="form" :rules="formRules" ref="form">
        <el-form-item label="Name" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="Prefix" prop="prefix">
          <el-input v-model="form.prefix" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="cancel">Cancel</el-button>
        <el-button type="primary" @click="create" :loading="creating">Create</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {

  data () {
    const isUnique = (rule, value, callback) => {
      this.channels.every(ch => ch.prefix !== value)
        ? callback()
        : callback(new Error('Prefix is already taken'))
    }
    return {
      dialogVisible: false,
      creating: false,
      form: {
        name: null,
        prefix: null
      },
      formRules: {
        name: [
          { required: true, message: 'Please input Name', trigger: 'blur' }
        ],
        prefix: [
          { required: true, message: 'Please input Prefix', trigger: 'blur' },
          { validator: isUnique, trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    ...mapActions('vouchers', ['createChannel']),
    create () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.creating = true
          try {
            const channel = { ...this.form }
            await this.createChannel(channel)
            this.$emit('create', channel)
            this.cancel()
          } finally {
            this.creating = false
          }
        }
      })
    },
    cancel () {
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    handleClose (done) {
      this.$refs.form.resetFields()
      done()
    }
  },

  computed: {
    ...mapGetters('vouchers', ['channels'])
  }
}
</script>




// WEBPACK FOOTER //
// src/components/vouchers/CreateChannel.vue